<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col cols="12">
                    <div class="grid-parent" v-if="secretPageContent">
                        <ProjectBox v-for="project in secretPageContent" :key="'secret_'+project.projectType+'_'+project.id" :project="project" :project-type="project.projectType" class="grid-child grid-child-third"></ProjectBox>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import _ from 'lodash'
    import ProjectBox from "../components/ProjectBox";

    export default {
        name: "SecretPage",
        components: {ProjectBox},
        computed: {
            secretPageContent: function () {
                if (this.$store.state.works.photos && this.$store.state.works.videos) {
                    var photos = this.$store.state.works.photos
                    var videos = this.$store.state.works.videos
                    var allWorks = _.concat(photos, videos)
                    var allWorksOrdered = _.orderBy(allWorks, 'sortscore', 'desc')

                    if (this.$route.name === 'SecretAdPage') {
                        return _.filter(allWorksOrdered, ['adpage', true])
                    } else if (this.$route.name === 'SecretEditorialPage') {
                        return _.filter(allWorksOrdered, ['editorialpage', true])
                    } else if (this.$route.name === 'SecretCastingPage') {
                        return _.filter(allWorksOrdered, ['castingpage', true])

                    } else {
                        return null
                    }
                } else {
                    return null
                }

            }
        },
        mounted() {
            this.$store.dispatch('GET_VIDEOS_FROM_API')
            this.$store.dispatch('GET_PHOTOS_FROM_API')

        }
    }
</script>

<style scoped>

</style>